import { Heading } from "@/components";
import useAddEdit from "./useEdit";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { tabs } from "./consts";
import { routes } from "@/routes/utils";
import { Outlet } from "react-router-dom";

const AddEdit = () => {
  const { onBackClick, breadcrumbData, navigate, action, id, activeTab } =
    useAddEdit();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={breadcrumbData[breadcrumbData.length - 1].name || ""}
            showBack
            onBackClick={onBackClick}
            breadcrumbData={breadcrumbData}
          />
        </div>
      </div>

      <Tabs
        value={activeTab}
        defaultValue="project-info"
        className="w-full my-3"
      >
        <TabsList className="w-full md:w-fit">
          {tabs?.map((data: any) => (
            <TabsTrigger
              key={data?.value}
              value={data?.value}
              onClick={() =>
                navigate(
                  `/${routes.pm}/${routes.projectOverview}/${id}/${action}/${data.value}`
                )
              }
            >
              {data?.title}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={activeTab}>
          <Outlet />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AddEdit;
